import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.header`
  ${({ theme, onlyLogo }) => css`
    background: #fff;
    padding: 20px 0;
    position: relative;
    -webkit-box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);

    ${onlyLogo &&
    css`
      border-bottom: 1px solid #eeeeee;
    `}

    .new-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      margin-right: 80px;
    }

    @media (max-width: ${theme.media.ipad}) {
      //height: 150px;
      padding: 13px;
    }
  `}
`

export const HColumsn = styled.div`
  display: block;
  font-size: 0;
`

export const HColumn = styled.div`
  ${({ theme }) => css`
    display: inline-block;
    vertical-align: middle;

    &:nth-of-type(1) {
      width: 14%;
    }

    &:nth-of-type(2) {
      /* width: 46%; */
    }

    &:nth-of-type(3) {
      width: 40%;
    }

    @media (max-width: ${theme.media.ipad}) {
      &:nth-of-type(1) {
        width: 40%;
      }

      &:nth-of-type(2) {
        display: none;
        /* width: 100%;
        float: left; */
      }

      &:nth-of-type(3) {
        width: 60%;
      }
    }
  `}
`

// export const MenuMobileIcon = styled.div`
//   ${({ theme }) => css`
//     display: flex;
//     align-items: center;
//     justify-content: center;

//     img {
//       width: 2.6rem;
//       height: 2.3rem;
//     }

//     &:hover {
//       background-color: ${theme.colors.primary};
//     }

//     ${media.greaterThan('medium')`
//       display: inline-block;
//     `}
//   `}
// `

export const MenuMobileIcon = styled.div`
  ${({ theme }) => css`
    display: none;
    width: 26px;
    height: 23px;
    font-size: 0;
    border: 0;
    position: absolute;
    top: 19px;
    cursor: pointer;

    img {
      width: 2.6rem;
      height: 2.3rem;
    }

    &:hover {
      img {
        filter: invert(22%) sepia(78%) saturate(2710%) hue-rotate(341deg)
          brightness(88%) contrast(96%);
      }
    }

    @media (max-width: ${theme.media.ipad}) {
      display: inline-block;
    }
  `}
`

export const Logo = styled.img`
  width: 15rem;

  ${media.lessThan('large')`
    margin-left: 5rem;
  `}

  ${media.lessThan('small')`
    /* margin-left: .8rem; */
    width: 85%;
  `}

  @media(max-width: 1170px) {
    max-width: 100px;
  }
`
export const HeaderNavigation = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 1.4rem;

  @media (max-width: 1170px) {
    .account {
      display: none;
    }
  }
`

export const HeaderNavigationItem = styled.div`
  ${({ active }) =>
    active &&
    css`
      z-index: 200;
      background: #ffffff;
    `}

  display: inline-block;
  position: relative;
  padding: 15px 8px;
  border-radius: 4px 4px 0 0;
  margin-right: 60px;
  /* width: 256px; */

  &:nth-of-type(2) {
    margin: 0 10px;
  }

  &:first-child {
    padding: 15px 15px;
  }

  &:last-child {
    padding: 15px 12px;
  }

  @media (max-width: 1390px) {
    padding: 15px 5px;
  }

  @media (max-width: 1245px) {
    padding: 15px 0;
  }
`

export const HeaderNavigationItemLink = styled.a`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    font-size: 14px;
    text-decoration: none;
    color: ${theme.colors.mediumGrey};
    /* background-color: gold; */

    transition: all 400ms;

    &:hover {
      color: ${theme.colors.primary};
    }

    /* img {
      margin-left: 0.6rem;
    } */

    ${media.lessThan('large')`
      font-size: 0;
      margin: 0 15px;
    `}
  `}
`

export const NavigationItemLinksIcons = styled.div`
  position: relative;
  vertical-align: middle;
  display: inline-block;

  ${({ theme }) => css`
    /* img {
      width: 28px;
      height: 28px;
      margin-right: 6px;

      &.icon-cart {
        background-color: #8f8f8f;
      }
    }

    img {
      width: 37px;
      margin-right: 6px;
      /* border-radius: 50%;
    } */

    .profile-img {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 37px;
      height: 37px;
      border-radius: 50%;
      margin-right: 10px;
      box-shadow: 0px 0px 0px 2px #fff, 0px 0px 0px 4px #f1f2f2;

      background-color: #e4e4e4;

      img {
        width: 20px;
      }
    }

    .counter-quantity {
      background: ${theme.colors.primary};
      border-radius: 50%;
      width: 20px;
      height: 20px;
      font-size: 10px;
      position: absolute;
      top: -9px;
      right: -6px;
      text-align: center;
      color: ${theme.colors.white};
      font-weight: bold;
      line-height: 21px;
    }
  `}
`

export const HeaderModalBox = styled.div`
  ${({ theme }) => css`
    background: #ffffff;
    border-radius: 5px;
    padding: 16px;
    position: relative;
    text-align: left;

    .header-modal-account & {
      width: 400px;
    }

    .header-modal-category & {
      min-width: 1000px;
      padding: 0;
    }

    .header-modal-cart & {
      width: 400px;
      border-radius: 10px 0 10px 10px;
      padding: 0;

      @media (max-width: ${theme.media.cel}) {
        width: 100%;
      }
    }

    .header-modal-local & {
      width: 360px;

      @media (max-width: ${theme.media.ipad}) {
        width: 100%;
      }
    }

    .header-modal-search & {
      padding: 30px;
    }

    .header-modal-profile & {
      padding: 30px 30px 10px 30px;
    }

    p {
      font-size: 14px;
      margin: 15px 0;
      display: block;
    }
  `}
`
